import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_portal-login_modal_login_with_code-action_unknown';

/**
 * /login-modal/login-with-code
 */
export function trackRetailerPortalLoginModalLoginWithCode(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
